import React, { useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import logoImage from "../assets/logo/Frame.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setPageTitle } from "../slice";

function Welcome() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClick = () => {
    navigate("/center");
  };

  useEffect(() => {
    dispatch(setPageTitle(""));
  }, [dispatch]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <img src={logoImage} alt="logo" style={{ maxWidth: "70vw", marginTop: "20px" }} />
      <Box display="flex" flexDirection="column" alignItems="end" width="70%" my={3}>
        <Typography variant="h1" textAlign="right" mb={3} fontWeight={700}>
          هدایی عزیز خوش آمدید
        </Typography>
        <Typography
          variant="h2"
          fontWeight={300}
          textAlign="justify"
          style={{ direction: "rtl" }}
          lineHeight={1.5}
        >
          مرکز هدا (همسان گزینی دانشگاهی ایران) اجرای طرح ملی همسان گزینی در دانشگاه ها است. این
          مرکز ارائه دهنده راهکاری است که می تواند به روشی نوین با تسهیل در امر ازدواج و همسان
          گزینی، گامی موثر در راستای گسترش فرهنگ ازدواج، از طریق انتخاب صحیح با محوریت خانواده،
          بردارد.
          <br />
          تسهیل در فرایند راستی آزمایی، اختصاصی بودن شبکه معرفین، سهولت یافتن افراد همسان، فراگیری
          بیش از 90 درصد جامعه جوان و بهره گیری از تسهیلات دانشگاهی از جمله ویژگی های مرکز همسان
          گزینی هدا می باشد.
        </Typography>
      </Box>
      <Box my={6}>
        <Button variant="m1" onClick={handleClick}>
          شروع کنیم{" "}
        </Button>
      </Box>
    </Box>
  );
}

export default Welcome;
